import { errorToast } from 'v2/utils/toasts'

// Embed mounts no console banners, so a Test agent that cannot start says why here.
export const embedTestErrorToast = (description: string) =>
  errorToast({ title: 'Unable to start the test', description })

// Embed has no profile to read a balance from; the runner still checks it before AI nodes.
export const shouldGateOnBalance = (prod: boolean, embed: boolean): boolean => prod && !embed

// Embed's PubNub grant covers a chat test's channel but no playground reply channel, so a reply
// without a chat channel (an SMS or WhatsApp conversation) cannot be sent from the embed.
export const canSendPlaygroundReply = (embed: boolean, chatChannel: string | undefined): boolean =>
  !embed || !!chatChannel
